<template>
  <div class="container-fluid bg-info text-white">
    <div class="row title-card">
      <div class="col-10 text-left"><b-link class="text-white" @click="backButton()"><span><icon name="cog" scale="2.5" spin v-show="spinner"></icon><icon name="arrow-circle-left" scale="2.5" v-show="back"></icon></span></b-link><h4 class="text-truncate">{{ score.nm_store }}</h4></div>
      <div class="col-2 text-right"><b-link class="text-white" :to="{ name: 'home' }"><icon name="times" scale="2"></icon></b-link></div>
    </div>
    <div class="row dark-background m-0 mb-1 pt-2 pb-2 pl-0 pr-0"><div class="col-12"><p class="m-0 p-0">ITEM</p><h4>{{ score.nm_check }}</h4></div></div>
    <div class="row dark-background m-0 mb-1 pt-2 pb-2 pl-0 pr-0"><div class="col-12"><p class="m-0 p-0">GRUPO</p><h4>{{ score.nm_group }}</h4></div></div>
    <div class="row m-0 mb-1 pt-2 pb-2 pl-0 pr-0">
        <div class="col-12">
            <p  class="m-0 p-0 text-white" v-html="score.ds_check.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
        </div>
    </div>
    <div class="row dark-background m-0 mb-1 pt-2 pb-2 pl-0 pr-0">
      <div class="col-6"><p class="m-0 p-0 text-white">Frequência: {{ score.nr_freq }}</p></div>
      <div class="col-6"><p class="m-0 p-0 text-white">Peso: {{ score.nr_factor }}</p></div>
    </div>
    <div class="row pt-3"><div class="col-12"><h4 class="text-info-h4">Últimas Avaliações</h4></div></div>
    <div role="tablist">
      <div v-for="(result, index) in score.results" v-bind:key="'r'+result.id_result" class="m-0">
        <b-row role="tab" class="p-0 m-0">
          <b-col cols="6" v-b-toggle="'t-'+index" class="dark-background m-0 mb-1 p-2"><h6 class="p-0 m-0">{{ result.dt_result }}</h6></b-col>
          <b-col cols="5" v-b-toggle="'t-'+index" class="dark-background m-0 mb-1 p-2 text-right">
              <strong v-if="result.vl_result == 0">Ok</strong>
              <strong v-if="result.vl_result == 1">-{{ score.nr_factor }}</strong>
          </b-col>
          <b-col class="dark-background delete m-0 ml-1 mb-1 p-0 p-0 pt-2 text-center">
              <b-link v-if="index == 0" s class="text-white" @click="deleteResult(result.id_result)"><icon name="trash" scale="1" ></icon></b-link>
              <span v-if="index > 0" s class="text-white"><icon name="window-minimize" scale="1" ></icon></span>
          </b-col>
        </b-row>
        <b-collapse v-bind:id="'t-'+index" accordion="results" role="tabpanel" class="mensagens">
          <ul class="p-2 m-0 mb-2">
            <li v-if="result.messages == ''">Sem mensagens.</li>
            <li v-for="(message, index) in result.messages" v-bind:key="'m'+index">
              <small>{{ message.dt_message }}<br> {{ message.nm_sender }}</small>
              <span v-if="message.tp_message == 'txt'">{{ message.ds_message }}</span>
              <span class="p-0 m-0" v-if="message.tp_message == 'img'">
                  <img :src="message.ds_message" class="img-fluid" v-bind="mainProps">
              </span>
            </li>
          </ul>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '../http'
import swal from 'sweetalert2'
import Icon from 'vue-awesome'

export default {
  components: { Icon },
  data () {
    return {
      spinner: true,
      back: false,
      score: {},
      mainProps: { blank: true, width: 100, height: 100, class: 'm1' },
    }
  },
  beforeCreate: function() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted () {
    // Verifica se está definida a informação da loja.
    if (this.$route.params.store) {
      // Armazenando a loja e o check no localStorage para o caso de reloads.
      localStorage.setItem('id_store', this.$route.params.store)
      localStorage.setItem('id_check', this.$route.params.check)
      // Consumindo o WS.
      http.get('/ranking/history/'+this.$route.params.store+'/'+this.$route.params.check)
        .then(response => {
          this.spinner = false;
          this.back = true;
          this.score = response.data;
        })
        .catch(error => {
          swal({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          })
        })
    }
    // Parâmetros não definidos na rota (provavelmente um reload).
    else {
      // Verifica se existe a última loja visitada no localStorage.
      if (localStorage.getItem('id_store') && localStorage.getItem('id_check')) {
        // Consumindo o WS com a loja e o check armazenada no localStorage.
        http.get('/ranking/history/'+localStorage.getItem('id_store')+'/'+localStorage.getItem('id_check'))
          .then(response => {
            this.spinner = false;
            this.back = true;
            this.score = response.data;
          })
      }
      else {
        this.backButton();
      }
    }
  },
  methods: {
    backButton () {
      this.$router.go(-1)
    },
    updateComponent(){
        var self = this;
        self.show = false;
        Vue.nextTick(function (){
          self.show = true;
        })
    },
    deleteResult (idResult) {
      swal.fire({
        title: 'Você tem certeza?',
        text: "Você não poderá reverter isso!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
            // Requisição para deltar o check.
            http.post('/checks/deletar', { id_result: idResult }).then(response => {
                swal.fire(
                    'Excluído!',
                    '',
                    'success'
                ).then((result) => {
                    if (result.value) {
                        location.reload();
                    }
                })

            })

        }
      })
      .catch(error => {
        swal({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        })
      })
    },
  }
}
</script>

<style scoped>
.container-fluid { min-height:100vh; }
.container-fluid .title-card { padding:20px 0; }
.container-fluid .title-card span { display:block; width:40px; height:40px; float:left; border-radius:20px; font-size:20px; color:#17A2B8; background:#FFF; line-height:40px; text-align:center; margin-right:24px; }
.container-fluid .title-card h4 { font-size:1.5em; color:#FFF; line-height:40px; }

.row p { font-size:13px; color:#094c56; }
.dark-background { background-color:#1592a5; }
p.text-white { font-size:16px; }
.text-info-h4 { color:#157e8e; }

.mensagens ul { list-style:none; }
.mensagens ul li { display:table; margin-bottom:10px; }
.mensagens ul li small { display:block; width:130px; float:left; color:#0b5560; }
.mensagens ul li span { display:block; float:left;}

.delete { }
</style>



// WEBPACK FOOTER //
// src/components/History.vue